module.exports = __webpack_public_path__ + "img/dokumen.a655444e.png";